// extracted by mini-css-extract-plugin
export default {"container":"style_container__CSUVy","page":"style_page__9CoNk","error":"style_error__0Y4bg"};